import { render, staticRenderFns } from "./demo_suitabledate_form.vue?vue&type=template&id=02a5909c&scoped=true&"
import script from "./demo_suitabledate_form.vue?vue&type=script&lang=js&"
export * from "./demo_suitabledate_form.vue?vue&type=script&lang=js&"
import style0 from "./demo_suitabledate_form.vue?vue&type=style&index=0&id=02a5909c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5909c",
  null
  
)

export default component.exports